export const createSaleURL = {
	url: "/products/sales",
	method: "POST",
};

// All master categories (ADMIN). Used to populate the category multi-select on
// the admin Create Sale / Create Coupon forms — the backend validates the ids
// against the DB, so they must be real.
export const getAllMasterCategoriesURL = {
	url: "/products/master-categories/all",
	method: "GET",
};

export const updateSaleURL = (saleId: string) => ({
	url: `/products/sales/${saleId}`,
	method: "PATCH",
});

export const deleteSaleURL = (saleId: string) => ({
	url: `/products/sales/${saleId}`,
	method: "DELETE",
});

export const getSaleURL = (query: string) => ({
	// query url: `/products/sales?page=0&size=10`,
	url: `/products/sales?${query}`,
	method: "GET",
});

export const updateSaleStatusURL = (saleId: string) => ({
	url: `/sales/${saleId}/update-status`,
	method: "PATCH",
});

export const getCustomerListURL = ({ page = 1, size = 8, search = "" }) => ({
	url: `/admin/customers?page=${page}&size=${size}${
		search ? `&search=${encodeURIComponent(search)}` : ""
	}`,
	method: "GET",
});

export const getCustomerOrdersURL = ({ customerId, page = 1, size = 8 }) => ({
	url: `/orders/customer/${customerId}?page=${page}&size=${size}`,
	method: "GET",
});

// ********** Sale Media **********

export const addSaleMediaURL = (saleId: string) => ({
	url: `/products/sales/${saleId}/add-media`,
	method: "PATCH",
});

export const deleteSaleMediaURL = (saleId: string, mediaKey: string) => ({
	url: `/products/sales/${saleId}/media/${mediaKey}`,
	method: "DELETE",
});
